import { callAuthorizedGraphQLEndpoint } from "module/graphQL";

// Counterpart to oppizi-api's `claimGuestDesign` mutation. Called right
// after the guest signs up — registers their work-in-progress flyer as a
// CampaignDesign owned by the new user/client. The visual state itself
// stays in MongoDB and gets copied client-side from the guest-namespaced
// roomId to the new authed roomId once we know the designId.

export type ClaimGuestDesignInput = {
  format?: string;
  fileName?: string;
  htmlContent?: string;
};

export type ClaimGuestDesignResponse = {
  success: boolean;
  error?: string;
  designId?: string | number;
  format?: string;
};

const MUTATION = `
  mutation claimGuestDesign($input: ClaimGuestDesignInput) {
    claimGuestDesign(input: $input) {
      success
      error
      designId
      format
    }
  }
`;

export const claimGuestDesign = async (input: ClaimGuestDesignInput): Promise<ClaimGuestDesignResponse> => {
  const response = (await callAuthorizedGraphQLEndpoint(MUTATION, { input })) as Response;
  const json = await response.json();
  const payload = json?.data?.claimGuestDesign as ClaimGuestDesignResponse | undefined;
  if (!payload) {
    const message =
      (Array.isArray(json?.errors) && json.errors[0]?.message) || `claimGuestDesign failed (${response.status})`;
    throw new Error(message);
  }
  return payload;
};
